<template>
  <form-rfq
    ref="Form"
    :data="data"
    :dataID="data.id"
    :model="getModel"
    @updateModelItem="handlerUpdateModelItem"
    @change="$emit('change', $event)"
  />
</template>

<script>
import FormWrapperAutoSave from '@/components/Form/FormWrapperAutoSave'
import { getCurrentEmployee } from '@/utils/shared'
export default {
  name: 'SectionRFQGeneral',
  mixins: [FormWrapperAutoSave],
  components: {
    'form-rfq': () => import(/* webpackChunkName: 'SupplierPoRFQ2' */ './FormRFQ.vue')
  },
  props: {
    data: { type: Object }
  },
  computed: {
    isAvailableToSave () {
      return true
    }
  },
  created () {
    this.$bus.$onPromise('validate-all-sections', this.validate)
  },
  beforeDestroy () {
    this.$bus.$offPromise('validate-all-sections', this.validate)
  },
  methods: {
    getModel () {
      return {
        id: null,
        rfqid: null,
        entryDate: new Date(),
        rfqTypeID: null,
        customerCompanyID: null,
        customerCompanyDetailID: null,
        customerContactID: null,
        po: '',
        poDate: null,
        baxEmployeeID: getCurrentEmployee().id
      }
    },
    handleClosePO () {
      return this.validate()
        .catch((e) => {
          throw new Error(this.L10n('rfq-general-error'))
        })
    },
    validate () {
      return this.$refs.Form.validate()
    }
  }
}
</script>
